import { measurementTypes } from "@pages/PatientOnboard/Constants"
import { router } from "@routers/routers";
import { IBodyRegionNormalized, IStatusNormalized } from "@stores/interfaces"
import { TFunction } from 'i18next';

export const BodyRegionNormalized: IBodyRegionNormalized = {
  full: 'Full Body',
  upperBody: 'Upper Body',
  upperRight: 'Upper Right',
  upperLeft: 'Upper Left',
  lowerBody: 'Lower Body',
  lowerRight: 'Lower Right',
  lowerLeft: 'Lower Left',
}

export const getMobilityData = (score: number, t: TFunction) => [
  {
    range: t('Patient.data.mobilityReport.range1'),
    title: t('Patient.data.mobilityReport.title1'),
    description:
      t('Patient.data.mobilityReport.description1'),
    icon: '/assets/limitless.svg',
    selectedIcon: '/assets/limitless-selected.svg',
    className: 'limitless',
    active: score >= 90,
    color: '#52C41A',
  },
  {
    range: t('Patient.data.mobilityReport.range2'),
    title: t('Patient.data.mobilityReport.title2'),
    description:
      t('Patient.data.mobilityReport.description2'),
    icon: '/assets/agile.svg',
    selectedIcon: '/assets/agile-selected.svg',

    className: 'agile',
    active: score >= 75 && score <= 89,
    color: '#73D13D',
  },
  {
    range: t('Patient.data.mobilityReport.range3'),
    title: t('Patient.data.mobilityReport.title3'),
    description:
      t('Patient.data.mobilityReport.description'),
    icon: '/assets/functional.svg',
    selectedIcon: '/assets/functional-selected.svg',

    className: 'functional',
    active: score >= 60 && score <= 74,
    color: '#FAAD14',
  },
  {
    range: t('Patient.data.mobilityReport.range4'),
    title: t('Patient.data.mobilityReport.title4'),
    description:
      t('Patient.data.mobilityReport.description4'),
    icon: '/assets/steady.svg',
    selectedIcon: '/assets/steady-selected.svg',

    className: 'steady',
    active: score >= 40 && score <= 59,
    color: '#F59712',
  },
  {
    range: t('Patient.data.mobilityReport.range5'),
    title: t('Patient.data.mobilityReport.title5'),
    description:
      t('Patient.data.mobilityReport.description5'),
    icon: '/assets/resilient.svg',
    selectedIcon: '/assets/resilient-selected.svg',

    className: 'resilient',
    active: score >= 20 && score <= 39,
    color: '#F2615B',
  },
  {
    range: t('Patient.data.mobilityReport.range6'),
    title: t('Patient.data.mobilityReport.title6'),
    description:
      t('Patient.data.mobilityReport.description6'),
    icon: '/assets/determined.svg',
    selectedIcon: '/assets/determined-selected.svg',
    
    className: 'determined',
    active: score < 20,
    color: '#D9363E',
  },
];

export const navigationConfig = {
  patientKey: { path: router.USERPATIENTVIEW },
  userActivity: { path: router.ACTIVITY },
  activity: { path: router.ACTIVITY },
  myReport: { path: router.AIASSISTANT_MY_REPORT },
  listEvaluation: { path: router.AIASSISTANT_LIST_EVALUATION },
  romSummary: { path: router.AIASSISTANT_ROM_SUMMARY },
  captures: { path: router.AIASSISTANT_CAPTURES },
  startScan: { path: router.AIASSISTANT_START_SCAN },
  startRomScan: { path: router.AIASSISTANT_START_ROM_SCAN },
  postureScan: { path: router.AIASSISTANT_POSTURE_SCAN },
  postureSummary: { path: router.AIASSISTANT_POSTURE_SUMMARY },
  postureCaptures: { path: router.AIASSISTANT_POSTURE_CAPTURES },
  customSummary: { path: router.AIASSISTANT_CUSTOM_SUMMARY },
  customCaptures: { path: router.AIASSISTANT_CUSTOM_CAPTURES },
  generateProgram: { path: router.AIASSISTANT_GENERATE_PROGRAM, state: { isGenerate: true } },
  programs: { path: router.AIASSISTANT_PROGRAMS, state: { isGenerate: false } },
  listSessions: { path: router.AIASSISTANT_LIST_SESSIONS },
  downloadApp: { path: router.DOWNLOAD_APP },
  surveySummary: { path: router.AIASSISTANT_SURVEY_SUMMARY },
  virtualEvaluation: { path: router.AIASSISTANT_VIRTUAL_EVALUATION },
  createReport: { path: router.AIASSISTANT_CREATE_REPORT },
  assignSurvey: {
    path: router.AIASSISTANT_ASSIGN_SURVEY,
    state: { openSurveyModal: true, isGenerate: true },
  },
  createSurvey: {
    path: router.AIASSISTANT_CREATE_SURVEY,
    state: { openSurveyModal: false, isGenerate: false },
  },
  patientKey: { path: router.USERPATIENTVIEW },
  startSurveyUser: { path: router.AIASSISTANT_START_SURVEY_USER },
  newPatients: { path: router.NEW_PATIENTS },
  outOfParams: { path: router.OUTOFPARAMETERS },
  pendingReview: { path: router.PENDINGREVIEW },
  reviewed: { path: router.REVIEWED },
  escalationRequired: { path: router.ESCALATIONREQUIRED },
  noComponentFound: { path: router.AIASSISTANT_PAGENOTFOUND },
  notUnderstandQuestion: { path: router.AIASSISTANT_SEARCHNOTFOUND },
  overview: { path: "overview" },
};

export const StatusNormalized: Omit<IStatusNormalized, 'newPatients'> = {
  pendingReview: 'Pending Review',
  outOfParams: 'Out Of Parameters',
  followUpRequired: 'Follow Up Required',
  escalationRequired: 'Escalation Required',
  reviewed: 'Reviewed'
}

export const limitPagination = 10

export const pagination = {
  isFirstPage: true,
  isLastPage: true,
  currentPage: 0,
  previousPage: 0,
  nextPage: 1,
  pageCount: 0,
  totalCount: 0
}

export const countdownTime = 3000

export const patientTimeLimit = 60000

export const adminTimeLimit = 10000

export const USER_ROLES = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'superadmin',
  USER: 'user'
}

export const ACTIVETAB = {
  ROM_SCAN_RESULTS: "romScanResults",
  HOME: 'home',
  DOWNLOAD_APP: "downloadApp",
  START_SCAN: 'startScan',
  ROM_SUMMARY: "romSummary",
  THEME: 'theme',
  OPENAI: 'OpenAi',
  TEMPLATES: 'templates',
  EXPORT_REPORTS: 'exportReports',
  CONTENT_MANAGER: 'contentManager',
  INVITE_CODE: 'InviteCode',
  PROGRAMS: 'programs',
  EVALUATION: 'Evaluation',
  OMNIROM: "OmniROM",
  SURVEYS: "Surveys",
  LETSMOVE: "Let's Move",
  ROMSUMMARY: 'romSummary',
  LIST_SESSIONS: "listSessions",
  SURVEYSUMMARY: 'surveySummary',
  LIST_EVALUATION: 'listEvaluation',
  ACTIVE_TAB: 'active-tab'
}

export const functionalGoalsMap: Record<string, number[]> = {
  "Recovery & Managing Discomfort": [1, 3, 4],
  "Functional Independence & Daily Living": [2, 8],
  "Performance Enhancement & Injury Prevention": [6, 7],
  "Holistic Well-being & Quality of Life": [5, 9, 10],
};

export const titleToIconMapOld: Record<string, number> = {
  "Recovery & Managing Discomfort": 1,
  "Functional Independence & Daily Living": 2,
  "Performance Enhancement & Injury Prevention": 3,
  "Holistic Well-being & Quality of Life": 4
};

export const MONTHS = [
  { value: 1, label: 'Jan' },
  { value: 2, label: 'Feb' },
  { value: 3, label: 'Mar' },
  { value: 4, label: 'Apr' },
  { value: 5, label: 'May' },
  { value: 6, label: 'Jun' },
  { value: 7, label: 'Jul' },
  { value: 8, label: 'Aug' },
  { value: 9, label: 'Sep' },
  { value: 10, label: 'Oct' },
  { value: 11, label: 'Nov' },
  { value: 12, label: 'Dec' },
]

export const DEFAULT_FORM_DATA = {
  firstName: '',
  lastName: '',
  email: '',
  imageUrl: '',
  birthDate: '',
  gender: '',
  imperialHeight: 0,
  metricHeight: 0,
  imperialWeight: 0,
  metricWeight: 0,
  isPregnant: false,
  consentPolicyRead: false,
  patientId: '',
  measurementSystem: measurementTypes.IMPERIAL,
  mobilePhone: '',
  weight: '',
  height: ''
};

export const THEME = {
  VIBRANT: 'vibrant',
  DARK: 'dark',
  DEFAULT: 'default'
}

export const activityKeys = ["sitting", "standing", "bending", "lifting", "walking", "sleeping"];

export const ROUTE_KEYS = {
  DOWNLOAD_APP: "download-app",
  PROGRAM_START: '/program/start',
  ROM_SCAN: '/rom/start-scan',
  POSTURE_SCAN: '/rom/posture-analytics/scan',
  ADD_EXERCISE: '/add-new-exercises'
}

export const ADMIN_MENU_CLICK = {
  PROFILE: 'profile',
  LOGOUT: 'logout',
  ASSESSMENT: 'assessment',
  THEME_SELECTOR: 'theme-selector',
  SETTINGS: 'settings',
  TOOLS: 'tools'
}

export const ADMIN_MENU = {
  NEW_PATIENTS: 'new-patients',
  REVIEWED: 'reviewed',
  PENDING_REVIEW: 'pending-review',
  FOLLOW_UP_REQUIRED: 'follow-up-required',
  ESCALATION_REQUIRED: 'escalation-required',
  OUT_OF_PARAMETERS: 'out-of-parameters',
  DEFAULT: ''
};

export const ADMIN_KEYS = {
  PATIENT_KEY: 'patientView',
  CONTACTS: 'contacts',
  ACTIVITY: 'activity',
  SUMMARY: 'summary',
  TOOLS: 'tools',
  USERACTIVITY: 'userActivity',
  GENERATE_PROGRAM: 'generateProgram',
  PATIENT_VIEW: 'patientView',
  SETTINGS: 'settings',
  UNASSIGNEDPATIENTS: 'unassigned-patients',
  PENDINGINVITES: 'pending-invites',
  REGISTEREDPATIENTS: 'registered-patients',
};

export const titleToIconMap: Record<string, number> = {
  "Functional Independence & Daily Living": 1,
  "Performance Enhancement": 2,
  "Injury Prevention": 3,
  "Holistic Well-being & Quality of Life": 4,
  "Managing Discomfort": 5,
  "Recovery": 6
};

export const GoalSelections = {
  "goals": [
    { "value": "1", "label": "Enhance Strength and Endurance" },
    { "value": "2", "label": "Increase Flexibility and Mobility" },
    { "value": "3", "label": "Improve overall fitness" },
    { "value": "4", "label": "Condition-Specific Rehabilitation and Recovery" },
    { "value": "5", "label": "Mental Wellness" },
    { "value": "6", "label": "Fall Prevention" },
  ],
  "experienceLevels": [
    { "value": "1", "label": "New to Fitness" },
    { "value": "2", "label": "Active but learning" },
    { "value": "3", "label": "Confident & Consistent" },
    { "value": "4", "label": "Athlete level Training" },
    { "value": "5", "label": "Returning from Injury or Condition" }
  ],
  "workoutPreferences": [
    { "value": "1", "label": "Strength & Resistance Training" },
    { "value": "2", "label": "Low Impact & Functional Training" },
    { "value": "3", "label": "Improve Yoga & Mindful movement" },
    { "value": "4", "label": "High Intensity ( Hiit & Cardio)" },
    { "value": "5", "label": "Post Injury Conditioning" }
  ],
  "timeAvailability": [
    { "value": "1", "label": "Quick & Efficient (< 20 min)" },
    { "value": "2", "label": "Balanced & Effective (20-40 min)" },
    { "value": "3", "label": "Comprehensive & Deep (40+ min)" }
  ]
}

export const INTAKE_STEPS = {
  INTAKE_PROGRAMS: 'intake-programs',
  SUGGESTED: 'suggested',
  STEP_PROGRAM: 'step-program'
}

export const INTAKE_BODYPOINTS = [
  {
    id: 0,
    name: 'Right Shoulder',
    position: 'front',
    styles: { top: '68px', left: '44px' },
    part: 'rightShoulder',
  },
  {
    id: 1,
    name: 'Left Shoulder',
    position: 'front',
    styles: { top: '68px', right: '44px' },
    part: 'leftShoulder',
  },
  {
    id: 12,
    name: 'Left Ankle',
    position: 'front',
    styles: { bottom: '24px', right: '92px' },
    part: 'leftAnkle',
  },
  {
    id: 20,
    name: 'Right Ankle',
    position: 'front',
    styles: { bottom: '24px', left: '92px' },
    part: 'rightAnkle',
  },
  {
    id: 2,
    name: 'Right Elbow',
    position: 'front',
    styles: { top: '125px', left: '30px' },
    part: 'rightElbow',
  },
  {
    id: 3,
    name: 'Left Elbow',
    position: 'front',
    styles: { top: '125px', right: '30px' },
    part: 'leftElbow',
  },
  {
    id: 6,
    name: 'Right Hip',
    position: 'front',
    styles: { top: '160px', left: '49px' },
    part: 'rightHip',
  },
  {
    id: 7,
    name: 'Left Hip',
    position: 'front',
    styles: { top: '160px', right: '49px' },
    part: 'leftHip',
  },
  {
    id: 8,
    name: 'Right Knee',
    position: 'front',
    styles: { bottom: '100px', left: '67px' },
    part: 'rightKnee',
  },
  {
    id: 9,
    name: 'Left Knee',
    position: 'front',
    styles: { bottom: '100px', right: '67px' },
    part: 'leftKnee',
  },
  {
    id: 9,
    name: 'Right Wrist',
    position: 'front',
    styles: { top: '170px', left: '15px' },
    part: 'rightWrist',
  },
  {
    id: 10,
    name: 'Left Wrist',
    position: 'front',
    styles: { top: '170px', right: '15px' },
    part: 'leftWrist',
  },
  {
    id: 11,
    name: 'Neck',
    position: 'front',
    styles: { top: '45px', left: '80px' },
    part: 'neck',
  },
  {
    id: 12,
    name: 'Spine',
    position: 'front',
    styles: { top: '145px', left: '80px' },
    part: 'spine',
  },
];

export const SORT_KEYS = {
  CREATED_AT: 'createdAt'
}

export const PATIENT_ONBOARD = {
  VIRTUAL_PT: 'virtualPt',
  NO_PAIN: 'noPain'
}

export const PLANS = {
  SELECT_ALL: 'selectAll',
  SCREENING: 'screening',
  EARLYINTERVENTION: 'earlyIntervention',
  VIRTUALPT: 'virtualPt',
  PLAN1: 'Plan 1',
  PLAN2: 'Plan 2',
  PLAN3: 'Plan 3'
}

export const PLANS_OPTIONS = [
  { id: '1', value: PLANS.SCREENING, label: 'Commit to Early Intervention', plan: PLANS.PLAN1 },
  { id: '2', value: PLANS.EARLYINTERVENTION, label: 'Get your Movement Credit Score', plan: PLANS.PLAN2 },
  { id: '3', value: PLANS.VIRTUALPT, label: 'Recover and Rejuvenate with Virtual Support', plan: PLANS.PLAN3 },
]

export const URL_PATH = {
  ROM:"rom",
  SCAN_RESULT:"scan-result"
}
